<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-column">
        <router-link :to="localizedPath('home')">
          <img src="https://auto-moto-sales.web.app/images/auto-moto-sales-logo.webp" :alt="$t('footer.companyLogo')" />
        </router-link>
      </div>
      <div class="footer-column">
        <h3>{{ $t('footer.quickLinks.title') }}</h3>
        <ul>
          <li><router-link :to="localizedPath('home')">{{ $t('footer.quickLinks.home') }}</router-link></li>
          <li><router-link :to="localizedPath('contact')">{{ $t('footer.quickLinks.contact') }}</router-link></li>
          <li><router-link :to="localizedPath('privacyPolicy')">{{ $t('footer.quickLinks.privacyPolicy')
              }}</router-link></li>
        </ul>
      </div>
      <div class="footer-column">
        <h3>{{ $t('footer.contact.title') }}</h3>
        <p><i class="fa fa-envelope" aria-hidden="true"></i> <a href="mailto:info@auto-moto-sales.ch">info@auto-moto-sales.ch</a></p>
        <p><i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:0629239966">0629239966</a></p>
        <p> AS Auto Moto Sales GmbH</p>
        <p><i class="fa fa-map-marker" aria-hidden="true"></i> Haldenstr. 72</p>
        <p><i class="fa fa-map-marker" aria-hidden="true"></i> 4900 Langenthal</p>
      </div>
    </div>
    <div class="container">
      <div class="credentials-footer">
        <span>Copyright © 2025 AS Auto Moto Sales GmbH</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    // ✅ Use computed properties to access the global `$localizedPath()`
    localizedPath() {
      return (routeKey) => {
        return this.$localizedPath(routeKey);
      };
    },

  }
};
</script>

<style scoped></style>
